import {render} from 'react';
import UpiContextProvider from '@providers/UpiContextProvider';
import UEStatusContainer from '@containers/UEStatus';

export default {
    init () {
        const ueProgress = document.getElementById( 'ue-status-progress' );
        const ueProgressNav = document.getElementById( 'nav-menu--ue-status-progress' ); 

        if ( ueProgress ) {
            render(
                <UpiContextProvider>
                    <UEStatusContainer className="w-full flex flex-col justify-between text-xl" showFullDetail={true}/>
                </UpiContextProvider>,
                ueProgress
            );
        }

        if ( ueProgressNav ) {
            // only access api if nav menu interacted with
            ueProgressNav.classList.add( 'w-full' );
            const navObserver = new IntersectionObserver( entries => {
                entries.map( entry => {
                    if ( entry.intersectionRatio > 0 ) {
                        render(
                            <UpiContextProvider>
                                <UEStatusContainer
                                    className="flex w-full text-center justify-around fade-in"
                                    size={101}/>
                            </UpiContextProvider>,
                            ueProgressNav
                        );
                        navObserver.unobserve( ueProgressNav );
                    }
                } )
            } );

            navObserver.observe( ueProgressNav )
        }
    }
}
